import React, { useEffect, useState } from 'react';
import { GraphicWalker } from '@kanaries/graphic-walker';

function App() {
  const [dataSource, setDataSource] = useState([]);

  const [fields] = useState([
    {
      "fid": "name_of_revolt",
      "semanticType": "nominal",
      "analyticType": "dimension"
    },
    // {
    //   "fid": "start_date",
    //   "semanticType": "temporal",
    //   "analyticType": "dimension"
    // },
    // {
    //   "fid": "end_date",
    //   "semanticType": "temporal",
    //   "analyticType": "dimension"
    // },
    {
      "fid": "continent",
      "semanticType": "nominal",
      "analyticType": "dimension"
    },
    {
      "fid": "monarchy",
      "semanticType": "nominal",
      "analyticType": "dimension"
    },
    {
      "fid": "relevance",
      "semanticType": "ordinal",
      "analyticType": "dimension"
    },
    {
      "fid": "longitude",
      "semanticType": "quantitative",
      "analyticType": "measure"
    },
    {
      "fid": "latitude",
      "semanticType": "quantitative",
      "analyticType": "measure"
    },
    {
      "fid": "country",
      "semanticType": "nominal",
      "analyticType": "dimension"
    },
    {
      "fid": "participants",
      "semanticType": "nominal",
      "analyticType": "dimension"
    },
    {
      "fid": "number_of_participants",
      "semanticType": "quantitative",
      "analyticType": "measure"
    },
    {
      "fid": "contributor",
      "semanticType": "nominal",
      "analyticType": "dimension"
    },
    {
      fid: "reasons_and_motivations",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "century",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "start_year",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "start_month",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "start_day",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "end_year",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "end_month",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "end_day",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    {
      fid: "decade",
      semanticType: "ordinal",
      analyticType: "dimension"
    },
    
    // SEASONS
    {
      fid: "start_season",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_anti_colonial",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_anti_seigneurial",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_economic",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    // {
    //   fid: "reason_economic_reforms",
    //   semanticType: "nominal",
    //   analyticType: "dimension"
    // },
    {
      fid: "reason_fiscal",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_food",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_freedom",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_labour",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_multiple",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    // {
    //   fid: "reason_natural_resources",
    //   semanticType: "nominal",
    //   analyticType: "dimension"
    // },
    {
      fid: "reason_others",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_political",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    // {
    //   fid: "reason_rebel_marron_communities",
    //   semanticType: "nominal",
    //   analyticType: "dimension"
    // },
    {
      fid: "reason_religion",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_maroon_resistance",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_military_issues",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "reason_resistance_to_conquest",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    // {
    //   fid: "reason_resistance_to_foreign_occupation",
    //   semanticType: "nominal",
    //   analyticType: "dimension"
    // },
    // africans, artisans, clergymen, enslaved, indigenous, local_elites, maroons, muncipal-council-cabildo, others, peasants, settlers_colonists, soldiers, undifferentiated, women, workers
    {
      fid: "participant_africans",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_artisans",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_clergymen",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_enslaved",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_indigenous",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_local_elites",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_maroons",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    // {
    //   fid: "participant_muncipal_council_cabildo",
    //   semanticType: "nominal",
    //   analyticType: "dimension"
    // },
    {
      fid: "participant_others",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_peasants",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_settlers_colonists",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_soldiers",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_undifferentiated",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_women",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    {
      fid: "participant_workers",
      semanticType: "nominal",
      analyticType: "dimension"
    },
    // add bolean values
    {
      fid: "related",
      semanticType: "nominal",
      analyticType: "dimension"
    }
    
    
  ]);

  useEffect(() => {
    function correctInvalidDate(dateString) {
      dateString = dateString.trim();
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/;
      const match = dateString.match(regex);
      if (!match) return dateString;
      let [, year, month, day] = match;
      if (month === '00') month = '01';
      if (day === '00') day = '01';
      return `${year}-${month}-${day}`;
    }
  
    // season function to be used in the data processing taking into account the country and the hemisphere
    function getSeason(month, country) {
      const countryHemispheres = {
        "Angola": "Southern",
        "Argentina": "Southern",
        "Belgium": "Northern",
        "Bolivia": "Southern",
        "Brazil": "Southern",
        "Cape Verde": "Northern",
        "Chile": "Southern",
        "Colombia": "Northern",
        "Costa Rica": "Northern",
        "Cuba": "Northern",
        "Dominican Republic": "Northern",
        "Ecuador": "Northern",
        "El Salvador": "Northern",
        "Guatemala": "Northern",
        "Guinea-Bissau": "Northern",
        "India": "Northern",
        "Italy": "Northern",
        "Japan": "Northern",
        "Macau": "Northern",
        "Mexico": "Northern",
        "Morocco": "Northern",
        "Mozambique": "Southern",
        "Netherlands": "Northern",
        "Nicaragua": "Northern",
        "Panama": "Northern",
        "Paraguay": "Southern",
        "Peru": "Southern",
        "Philippines": "Northern",
        "Portugal": "Northern",
        "Puerto Rico": "Northern",
        "S. Tome&Prin.": "Northern",
        "Spain": "Northern",
        "Sri Lanka": "Northern",
        "Timor": "Northern",
        "Uruguay": "Southern",
        "US-Louisiana": "Northern",
        "US-New Mexico": "Northern",
        "Venezuela": "Northern"
      };
      const hemisphere = countryHemispheres[country];
  
      if (hemisphere === "Northern") {
        if (month >= 3 && month <= 5) return "Spring";
        if (month >= 6 && month <= 8) return "Summer";
        if (month >= 9 && month <= 11) return "Autumn";
        return "Winter";
      } else {
        if (month >= 3 && month <= 5) return "Autumn";
        if (month >= 6 && month <= 8) return "Winter";
        if (month >= 9 && month <= 11) return "Spring";
        return "Summer";
      }
    }

    const processData = (item) => {
      // const processParticipants = (value) => {
      //   if (!value) return null;
      //   return value[0].replace('&gt;', '>').replace('&lt;', '<');
      // };
      const getCentury = (dateString) => {
        const year = parseInt(dateString?.split('-')[0], 10);
        return Math.floor((year - 1) / 100) + 1;
      };

      const getDecade = (dateString) => {
        if (!dateString) return null;
        // const year = new Date(dateString).getFullYear();
        const year = parseInt(dateString.split('-')[0], 10);
        return Math.floor(year / 10) * 10;
      }

      return {
        ...item,
        // start_date: correctInvalidDate(item.start_date),
        // end_date: correctInvalidDate(item.end_date),
        start_year: item.start_date_year ? parseInt(item.start_date_year, 10) : null,
        end_year: item.end_date_year ? parseInt(item.end_date_year, 10) : null,
        start_month: item.start_date_month ? parseInt(item.start_date_month, 10) : null,
        end_month: item.end_date_month ? parseInt(item.end_date_month, 10) : null,
        start_day: item.start_date_day ? parseInt(item.start_date_day, 10) : null,
        end_day: item.end_date_day ? parseInt(item.end_date_day, 10) : null,
        start_season: getSeason(new Date(correctInvalidDate(item.start_date)).getMonth() + 1, item.country),
        // start_month: new Date(correctInvalidDate(item.start_date)).getMonth() + 1,
        // end_month: new Date(correctInvalidDate(item.end_date)).getMonth() + 1,
        number_of_participants: convertToNumber(item.number_of_participants[0]),
        country: item.country?.join(', ') || 'Unknown',
        continent: item.continents?.join(', ') || 'Unknown',
        participants: item.participants?.join(', ') || 'Unknown',
        latitude: parseFloat(item.latitude),
        longitude: parseFloat(item.longitude),
        century: getCentury(item.start_date),
        // start_year: parseInt(item.start_date?.split('-')[0], 10),
        // end_year: parseInt(item.end_date?.split('-')[0], 10),
        decade: getDecade(item.start_date),
        reasons_and_motivations: item.reasons_and_motivations,
        reason_political: item.reasons_and_motivations.includes("Political") ? "Yes" : "No",
        reason_economic: item.reasons_and_motivations.includes("Economic") ? "Yes" : "No",
        reason_freedom: item.reasons_and_motivations.includes("Freedom") ? "Yes" : "No",
        reason_food: item.reasons_and_motivations.includes("Food") ? "Yes" : "No",
        reason_fiscal: item.reasons_and_motivations.includes("Fiscal") ? "Yes" : "No",
        reason_labour: item.reasons_and_motivations.includes("Labour") ? "Yes" : "No",
        // reason_natural_resources: item.reasons_and_motivations.includes("Natural resources") ? "Yes" : "No",
        reason_anti_colonial: item.reasons_and_motivations.includes("Anti-colonial") ? "Yes" : "No",
        reason_anti_seigneurial: item.reasons_and_motivations.includes("Anti-seigneurial") ? "Yes" : "No",
        // reason_economic_reforms: item.reasons_and_motivations.includes("Economic reforms") ? "Yes" : "No",
        reason_multiple: item.reasons_and_motivations.includes("Multiple") ? "Yes" : "No",
        reason_others: item.reasons_and_motivations.includes("Others") ? "Yes" : "No",
        reason_religion: item.reasons_and_motivations.includes("Religion") ? "Yes" : "No",
        // reason_resistance_to_foreign_occupation: item.reasons_and_motivations.includes("Resistance to foreign occupation") ? "Yes" : "No",
        // reason_rebel_marron_communities: item.reasons_and_motivations.includes("Rebel marron communities") ? "Yes" : "No",
        participant_africans: item.participants.includes("Africans") ? "Yes" : "No",
        participant_artisans: item.participants.includes("Artisans") ? "Yes" : "No",
        participant_clergymen: item.participants.includes("Clergymen") ? "Yes" : "No",
        participant_enslaved: item.participants.includes("Enslaved") ? "Yes" : "No",
        participant_indigenous: item.participants.includes("Indigenous") ? "Yes" : "No",
        participant_local_elites: item.participants.includes("Local elites") ? "Yes" : "No",
        participant_maroons: item.participants.includes("Maroons") ? "Yes" : "No",
        reason_maroon_resistance: item.reasons_and_motivations.includes("Maroon resistance") ? "Yes" : "No",
        reason_military_issues: item.reasons_and_motivations.includes("Military issues") ? "Yes" : "No",
        reason_resistance_to_conquest: item.reasons_and_motivations.includes("Resistance to conquest") ? "Yes" : "No",
        // participant_muncipal_council_cabildo: item.participants.includes("Muncipal council cabildo") ? "Yes" : "No",
        participant_others: item.participants.includes("Others") ? "Yes" : "No",
        participant_peasants: item.participants.includes("Peasants") ? "Yes" : "No",
        participant_settlers_colonists: item.participants.includes("Settlers/Colonists") ? "Yes" : "No",
        participant_soldiers: item.participants.includes("Soldiers") ? "Yes" : "No",
        participant_undifferentiated: item.participants.includes("Undifferentiated") ? "Yes" : "No",
        participant_women: item.participants.includes("Women") ? "Yes" : "No",
        participant_workers: item.participants.includes("Workers") ? "Yes" : "No",
      };
    };

    const convertToNumber = (value) => {
      switch (value) {
        case "unknown":
          return null; // or you can use a specific number like -1 to indicate unknown
        case ">500":
          return 501; // Use a representative number for >500
        case "<50":
          return 49; // Use a representative number for <50
        case "100-250":
          return (100 + 250) / 2; // Average of the range
        case "250-500":
          return (250 + 500) / 2; // Average of the range
        case "50-100":
          return (50 + 100) / 2; // Average of the range
        default:
          return null; // Fallback for unexpected values
      }
    };
    const fetchData = async () => {
      // fetch('http://localhost:8080/wp-json/revoltsplugin/v1/revolts/')
      fetch('http://atlas.cidehusdigital.uevora.pt/wp-json/revoltsplugin/v1/revolts/')
      // fetch('/wp-json/revoltsplugin/v1/revolts/')
        .then((response) => response.json())
        .then((result) => {
          const updatedData = result.map(processData);
          setDataSource(updatedData)
        })
      }
    fetchData()
  }, [])

  return (
    <div className="App">
      <header className="App-header">
        <GraphicWalker
          fields={fields}
          data={dataSource}
          appearance="light"
        />
      </header>
    </div>
  );
}

export default App;